/**
 * RbsPortalBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceDto } from './invoiceDto';


export interface InvoiceLineDto { 
    id?: number;
    this2InvoiceNavigation?: InvoiceDto;
    offsetAccount?: string | null;
    costCenter?: string | null;
    costUnit?: string | null;
    amount?: number;
}

